<script setup>
import { ref } from 'vue'
import { getSearchAPI } from '@/apis/home'
import HeaderLanguage from '@/views/Layout/components/HeaderLanguage.vue'
import HeaderCart from '@/views/Layout/components/HeaderCart.vue'
import HeaderUserImg from '@/views/Layout/components/HeaderUserImg.vue'
import Notify from '@/views/Layout/components/Notify.vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/userStore';
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n();
const userStore = useUserStore()
const router = useRouter()
const content = ref('')
const currentRoute = ref(router.currentRoute.value.path);

// 监听路由变化
watch(
    () => router.currentRoute.value.path,
    (newPath) => {
        currentRoute.value = newPath;
    }
);
const fullscreenLoading = ref(false)
const goCategory = async () => {
    fullscreenLoading.value = true
    try {
        console.log(objectString.value)
        const res = await getSearchAPI({ keyword: content.value })
        if (res.code == 0) {

            results.value = res.data.data
            fullscreenLoading.value = false
            if (res.data.third_party_data.from) {
                // 将对象转换为JSON字符串
                objectString.value = JSON.stringify(res.data.third_party_data);
                localStorage.setItem('thirdData', objectString.value)
                console.log('搜索值', res.data.third_party_data)
            }
            if (res.data.third_party_data.from) {

                // if(currentRoute.value =='/externals'){
                //     window.location.reload();
                // }else{
                router.push({ path: '/externals/' + res.data.third_party_data.from + '/' + res.data.third_party_data.product_id })
                // }
            } else {
                router.push({ path: '/category/sub/2/' + content.value })
                localStorage.setItem('thirdData', '')
            }

        } else {
            fullscreenLoading.value = false

            ElMessage({ type: 'error', message: res.message })
        }
    } catch (error) {

        fullscreenLoading.value = false
    }





}
const handleKeyDown = (event) => {
    if (event.keyCode === 13) { // 回车键的 keyCode 是 13
        goCategory()
        // 你的逻辑代码
        // console.log('回车键被按下');
        // event.preventDefault(); // 阻止默认行为，如表单提交
    }
}
const objectString = ref()
const results = ref([])

const onSearch = async (content) => {

    console.log(content)
    // 模拟搜索结果
    if (content == '' || content == undefined) {
        results.value = [];
    } else {
        console.log(content)

        const res = await getSearchAPI({ keyword: content })
        if (res.code == 0) {
            results.value = res.data.data

            if (res.data.third_party_data.from) {
                // 将对象转换为JSON字符串
                objectString.value = JSON.stringify(res.data.third_party_data);
                localStorage.setItem('thirdData', objectString.value)
            }

        } else {
            ElMessage({ type: 'error', message: res.message })
        }
    }
}
const setCategory = (zhi) => {
    content.value = zhi
    router.push({ path: '/category/sub/2/' + content.value })
}
const isMobile = ref(false);//false代表pc
onMounted(() => {
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    console.log('Is mobile device:', isMobile.value);
})
</script>
<template>
    <div class="container" v-loading.fullscreen.lock="fullscreenLoading">

        <RouterLink to="/">
            <h1 class="logo">
                <img style="width: 44px; height: 50px;" src="../../assets/images/login.png" alt="" srcset="">
            </h1>
        </RouterLink>
        <div class="search">
            <div class="search-container">
                <input type="text" class="search-input" :placeholder="t('setup28')" @input="onSearch(content)"
                    v-model="content" @keydown="handleKeyDown" clearable />
                <div style="display: flex;margin-right: 32px" v-if="content == ''">
                    <div class="icon">
                        <svg-icon icon-class="taobao" style="width: 26px;height: 26px;" />
                    </div>
                    <div class="icon">
                        <svg-icon icon-class="1688" style="width: 26px;height: 26px;" />
                    </div>
                    <div class="icon">
                        <svg-icon icon-class="dian" style="width: 26px;height: 26px;" />
                    </div>
                </div>
                <div class="searchbut HorizontalCenter" @click="goCategory()"><img src="../../assets/images/search.png"
                        style="width: 24px;height: 24px;" alt="" srcset=""></div>
            </div>
            <div class="resule" v-if="results && results.length > 0">
                <ul>
                    <li v-for="(result, index) in results" :key="index" @click="setCategory(result.text)">{{ result.text
                    }}</li>
                </ul>
            </div>
        </div>

        <div class="tab">
            <!-- 语言切换 -->
            <HeaderLanguage />
            <div style="margin-left: 15px;margin-right: 8px;" @click="router.push('/estimation')"><img
                    src="../../assets/images/yunfei.png" alt="" style="width: 28px;height: 25px;margin-right: 8px;">{{
                        $t('setup480') }}</div>
            <!-- 头部购物车 -->
            <HeaderCart v-if="isMobile == false" />
            <Notify v-if="userStore.userInfo.token" />
            <!-- 用户头像 -->
            <HeaderUserImg />
        </div>
    </div>
</template>


<style scoped lang='scss'>
.container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 70px;
}

.logo {
    // width: 200px;
    // background: linear-gradient(to right, #56a9ff, #f56c6c);
    // -webkit-background-clip: text;
    // color: transparent;
    // font-size: 35px;
    // /* padding-left: 16px; */
    // font-weight: 700;
}

.search-container {

    display: flex;
    align-items: center;
    background-color: #ffffff;
    padding: 1px 0px 1px 10px;
    /* border-radius: 60px; */
    width: 495px;
    height: 38px;
    /* border: 1px solid #eee; */
    background: #FFFFFF;
    border: 1px solid #FC3938;
}

.search-input {
    border: none;
    outline: none;
    padding: 0 10px;
    border-radius: 20px;
    flex-grow: 1;
    margin-right: 10px;
}

.search-button {
    background-color: #ff4d4f;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 20px;
    cursor: pointer;
}

.search-button:hover {
    background-color: #e03e3e;
}

.icon {
    margin-left: 10px;
    width: 24px;
    height: 24px;
    // background-color: #ddd;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.searchbut {
    width: 46px;
    height: 38px;
    background: #FC3938;
}

//   .icon:hover {
//     background-color: #ccc;
//   }
.resule {
    border-radius: 10px;
    position: fixed;
    top: 62px;
    background-color: #fff;
    z-index: 99999;
    width: 500px;
    height: 200px;
    overflow: auto;

    ul {
        li {
            padding: 0 10px;

            &:hover {

                background-color: #f4f4f8;
            }
        }
    }
}

.search {
    // height: 40px;
    // padding: 0 8px;
    // border: 1px solid #eee;
    // background-color: #f8f8f8;
    // border-radius: 25px;
    // width: 400px;
    position: relative;
    line-height: 32px;
    display: flex;
    align-items: center;

    // .icon-search {
    //     font-size: 18px;
    //     margin-left: 18px;
    //     margin-right: 10px;
    // }

    // input {
    //     width: 210px;
    //     padding-left: 5px;
    //     color: #666;
    //     padding: 0;
    //     height: 32px;
    //     border: 0;
    //     background-color: transparent;
    //     outline: 0;
    //     box-shadow: none !important;
    // }


}

.cart {
    // width: 50px;

    .curr {
        height: 32px;
        line-height: 32px;
        text-align: center;
        position: relative;
        display: block;

        .icon-cart {
            font-size: 22px;
        }

        em {
            font-style: normal;
            position: absolute;
            right: 0;
            top: 0;
            padding: 1px 6px;
            line-height: 1;
            background: $helpColor;
            color: #fff;
            font-size: 12px;
            border-radius: 10px;
            font-family: Arial;
        }
    }
}

.tab {
    display: flex;
    align-items: center;


}



.app-header-nav {
    width: 820px;
    display: flex;
    padding-left: 40px;
    position: relative;
    z-index: 998;

    li {
        margin-right: 40px;
        width: 38px;
        text-align: center;

        a {
            font-size: 16px;
            line-height: 32px;
            height: 32px;
            display: inline-block;

            &:hover {
                color: $xtxColor;
                border-bottom: 1px solid $xtxColor;
            }
        }

        .active {
            color: $xtxColor;
            border-bottom: 1px solid $xtxColor;
        }
    }
}
</style>